import React, { createContext } from 'react';

const CustomerProductContext = createContext();

export default CustomerProductContext;